import Select from "react-select";
import { getCustomSelectStyles } from "../../admin/shared";
import type { AssignableUser } from "../services/serviceDeskService";

interface SelectOption {
  value: string;
  label: string;
}

interface AgentSelectorProps {
  value: string | null | undefined;
  onChange: (agentId: string | null) => void;
  isDarkMode: boolean;
  users: AssignableUser[];
  placeholder?: string;
  isClearable?: boolean;
  isDisabled?: boolean;
}

export function AgentSelector({
  value,
  onChange,
  isDarkMode,
  users,
  placeholder = "Seleccionar agente...",
  isClearable = true,
  isDisabled = false,
}: AgentSelectorProps) {
  const options: SelectOption[] = users.map((u) => ({
    value: u.id,
    label: u.name,
  }));

  const selectedOption = options.find((opt) => opt.value === value) ?? null;

  return (
    <Select<SelectOption>
      value={selectedOption}
      onChange={(option) => onChange(option?.value ?? null)}
      options={options}
      placeholder={placeholder}
      isSearchable
      isClearable={isClearable}
      isDisabled={isDisabled}
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      styles={getCustomSelectStyles(isDarkMode) as any}
      noOptionsMessage={() => "Sin agentes disponibles"}
      menuPortalTarget={document.body}
      menuPosition="fixed"
    />
  );
}
